module.exports = __webpack_public_path__ + "img/what-is-ocr.0b4a70c2.png";